import type { BuildingEntityBase } from "building-types/entities/buildingEntityBase";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { ViewEntityDescriptor } from "building-types/views/viewEntityTypes";
import type { RWTable } from "common/data/table";
import type { BRep, Face } from "geom/brep";
import type { PlaneBSP } from "geom/bspTypes";
import type { PolyLine2 } from "geom/polyLine2Types";

export type WallWainscotingFaces = {
  [wallId: string]: { halfEdge: number; startFaceIndex: number; numFaces: number }[];
};

export interface Wainscoting extends BuildingEntityBase<"WAINSCOTING"> {
  readonly levelId: string;
  readonly faces: Face[];
  readonly trims: BRep[];
  readonly wainscotingDescriptor: ViewEntityDescriptor;
  readonly capDescriptor: ViewEntityDescriptor;
  readonly thickness: number;
  readonly faceInfo: WallWainscotingFaces;
  readonly wallCuts: WainscotingWallSegments[];
  readonly wallBases: WainscotingWallSegments[];
  readonly facePickHandles?: readonly (DocEntityHandle | undefined)[];
  readonly trimPickHandles?: readonly (DocEntityHandle | undefined)[];
  readonly faceReportingUnitHandles?: readonly (DocEntityHandle | undefined)[];
  readonly trimReportingUnitHandles?: readonly (DocEntityHandle | undefined)[];
}

export interface GenerateWainscotingContext {
  wainscoting: RWTable<Wainscoting>;
  leftClipPlane?: PlaneBSP;
  rightClipPlane?: PlaneBSP;
}

export interface FrontInfo {
  edgeAtFront: boolean[];
  leftClipPlane: PlaneBSP | null;
  rightClipPlane: PlaneBSP | null;
}

export interface WainscotingWallSegments {
  readonly halfEdgeIndex: number;
  readonly segments: PolyLine2[];
}

export function wainscotingWallSegmentsNew(halfEdgeIndex: number, segments = []): WainscotingWallSegments {
  return { halfEdgeIndex, segments };
}
